import { Command } from './Command';

export type GetPatientIdentifierParams = {
	birthNumber: string;
};

export const GetPatientIdentifier = (
	params: GetPatientIdentifierParams,
): Command => {
	return {
		operation: 'DajJRUZIdentifikator_GW_v2',
		params,
	};
};
